/* eslint-disable no-param-reassign */
import filter from 'lodash/filter';
import set from 'lodash/set';

import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

import { SpaceAccessRequestStatus, SpaceData, SpacePinnedResource } from '../types';

export const domain = 'space';

export interface SpaceState {
    hasInit: boolean;
    isLoading: boolean;
    isMembershipRequestLoading: boolean;
    isNavigationAdminDialogOpen: boolean;
    hasError: boolean;
    errorStatus?: number;
    data: SpaceData | null;
    id: string | null;
}

export const initialState: SpaceState = {
    hasInit: false,
    isLoading: false,
    isMembershipRequestLoading: false,
    isNavigationAdminDialogOpen: false,
    hasError: false,
    data: null,
    id: null,
};

export const { actions, reducer } = createSlice({
    domain,
    initialState,
    reducers: {
        reset: () => initialState,
        request: (state: SpaceState) => {
            state.hasInit = true;
            state.isLoading = true;
        },
        success: (state: SpaceState, action: PayloadAction<{ data: SpaceData; id: string }>) => {
            state.isLoading = false;
            state.data = action.payload.data;
            state.id = action.payload.id;
            state.hasError = false;
            state.errorStatus = undefined;
        },
        failure: (state: SpaceState, action: PayloadAction<number | undefined>) => {
            state.isLoading = false;
            state.hasError = true;
            state.errorStatus = action.payload;
        },
        requestAccessRequest: (state: SpaceState) => {
            state.isMembershipRequestLoading = true;
        },
        requestAccessSuccess: (state: SpaceState) => {
            state.isMembershipRequestLoading = false;
            set(state, 'data.myMembership.requestDetails', { status: SpaceAccessRequestStatus.pending });
        },
        requestAccessFailure: (state: SpaceState) => {
            state.isMembershipRequestLoading = false;
        },
        pinResource: (state: SpaceState, action: PayloadAction<SpacePinnedResource>) => {
            const newPinnedResources = [...(state.data?.pinnedResources ?? []), action.payload];
            set(state, 'data.pinnedResources', newPinnedResources);
        },
        unpinResource: (state: SpaceState, action: PayloadAction<SpacePinnedResource>) => {
            const newPinnedResources = filter(state.data?.pinnedResources ?? [], (resource) => {
                return resource.id !== action.payload.id;
            });
            set(state, 'data.pinnedResources', newPinnedResources);
        },
        openNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = true;
        },
        closeNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = false;
        },
    },
});
